import * as SpecialActionIds from 'automation-ui-flow-core/canvas/SpecialActionIds';
import { cleanActionGoToBranches } from 'automation-ui-canvas/flow/utils/cleanListBranchGoToBranches';
export function updateExistingBranchAction({
  action,
  defaultBranchName,
  branches,
  flow,
  branchesToDelete,
  rootLoopNodeId
}) {
  let newAction = action;
  let newFlow = flow;
  const connection = action.getConnection();
  const newConnection = connection && connection.setBranches(branches).sanitizeBranchConnection(rootLoopNodeId).setDefaultBranchName(typeof defaultBranchName === 'string' ? defaultBranchName : connection.getDefaultBranchName());
  newAction = newAction.set('connection', newConnection);
  branchesToDelete.forEach(branch => {
    const connector = branch.getConnector();
    if (connector && !connector.isGoToEdge()) {
      const nextActionId = connector.getNextActionId();
      newFlow = newFlow.removeAction(Number(nextActionId), true);
    }
  });
  newAction = cleanActionGoToBranches({
    flow: newFlow,
    action: newAction
  });
  newFlow = newFlow.replaceAction(newAction);
  return newFlow;
}
export const updateBranchAction = ({
  flow,
  action,
  actionId,
  rootLoopNodeId,
  edgeId,
  branches,
  branchesToDelete = [],
  branchIndexToSetDownstreamActionsIn,
  deleteDownstreamActions,
  defaultBranchName
}) => {
  if (action.isNew()) {
    return flow.removeAction(SpecialActionIds.NEW_ACTION).insertAction({
      action,
      actionId,
      rootLoopNodeId,
      edgeId,
      branches,
      branchIndexToSetDownstreamActionsIn,
      deleteDownstreamActions,
      defaultBranchName
    });
  } else {
    return updateExistingBranchAction({
      flow,
      action,
      branches,
      branchesToDelete,
      defaultBranchName,
      rootLoopNodeId
    });
  }
};